import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Reel} from "./Reel";
import {LayersSet} from "./LayersSet";
import {XwaysHoarder2Statics} from "../XwaysHoarder2Statics";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap, Linear} from "gsap";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {BasicSymbol, SymbolStates} from "./symbols/BasicSymbol";


export class ReelsView extends PIXI.Container implements StageLayer {

    public reels: Reel[] = [];
    public logo: PIXI.Sprite;
    name = "ReelView";
    public effectsLayer: PIXI.Container;
    private areaResizeAnimation: gsap.core.Timeline | undefined;
    private layers: LayersSet;
    //public frame:ReelFrame;
    private _currentMode?: string;
    private _symbolMask: PIXI.Graphics;
    private reelsNoWinOverlay: PIXI.Sprite;
    private _respinOverlay: PIXI.Sprite | null;

    constructor() {
        super();
        this.init();
    }

    public createReels() {
        for (let i: number = 0; i < XwaysHoarder2Statics.NR_OF_REELS; i++) {
            const reel = new Reel(i);
            this.reels.push(reel);
            this.layers.addLayerSet(reel.layers);
        }

        //reversing child order of winLayers
        this.layers.winOver.children.reverse();
    }

    public changeReelSets(mode: GameMode, nextLevel: number) {
        for (let reel of this.reels) {
            reel.changeReelSet(mode, nextLevel);
        }
    }

    public initReels(freeSpinMode: boolean = false, reels: string[][]) {
        const reelSizes = XwaysHoarder2Statics.defaultGameAreaSize;
        for (let i: number = 0; i < XwaysHoarder2Statics.NR_OF_REELS; i++) {
            const reel = this.reels[i];
            reel.init(reels[i]);
            reel.position.set(XwaysHoarder2Statics.symbolWidth * i, 0);
            reel.pivot.set(0, XwaysHoarder2Statics.symbolHeight * reelSizes[i] * 0.5);
        }
    }

    onResize(): void {

        this.resizeArea(0);

        if (NolimitApplication.isLandscape) {
            this._symbolMask.position.set(-136, 136);
            this._symbolMask.scale.set(1, 1);
            this.effectsLayer.position.set(this.layers.maskedNormal.position.x, this.layers.maskedNormal.position.y);
            this.effectsLayer.scale.set(1, 1);
        } else {
            this._symbolMask.position.set(0, 202);
            this._symbolMask.scale.set(0.75, 0.75);
            this.effectsLayer.position.set(this.layers.maskedNormal.position.x, this.layers.maskedNormal.position.y);
            this.effectsLayer.scale.set(0.75, 0.75);
        }
    }

    public scaleReelsForMode(mode?: string, duration: number = 0.001) {
        this._currentMode = mode;
        return this.resizeArea(duration);
    }

    public resizeArea(duration: number = 0.0001): gsap.core.Timeline {  // From jingleballs

        if (this.areaResizeAnimation && this.areaResizeAnimation.isActive()) {
            duration = this.areaResizeAnimation.duration() * (1 - this.areaResizeAnimation.progress());
            this.areaResizeAnimation.kill();
        }

        const width = XwaysHoarder2Statics.symbolWidth * 6;
        const height = XwaysHoarder2Statics.symbolHeight * 5;
        let yOffset = 28;

        const margin = new PIXI.Point(
            NolimitApplication.isLandscape ? 200 : 60,
            NolimitApplication.isLandscape ? 60 : 280
        );

        let scale = NolimitApplication.isLandscape ? 1 : 0.75;
        /*Math.min(1, Math.min(
            (NolimitApplication.screenBounds.width - margin.x) / width,
            (NolimitApplication.screenBounds.height - margin.y) / height,
        ));*/

        const position = new PIXI.Point(
            360 - width * scale * 0.5,
            (360 + yOffset),
        )

        this.areaResizeAnimation = gsap.timeline();
        for (let layer of this.layers.all) {
            this.areaResizeAnimation.add(gsap.to(layer, {
                duration: duration,
                pixi: {scale: scale, x: position.x, y: position.y}
            }), 0);
        }

        /*this.areaResizeAnimation.add(gsap.to(this.frame.bottomView, {
            duration:duration,
            pixi:{scale:scale, x:360, y:position.y}
        }), 0);

        this.areaResizeAnimation.add(gsap.to(this.frame.topView, {
            duration:duration,
            pixi:{scale:scale, x:360, y:position.y}
        }), 0);*/

        this.areaResizeAnimation.add(() => {
            delete this.areaResizeAnimation;
        });

        return this.areaResizeAnimation;
    }

    public showReels(duration: number = 0.001): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(gsap.to(this, {duration: duration, alpha: 1}));
        return tl;

    }

    public hideReels(duration: number = 0.001): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(gsap.to(this, {duration: duration, alpha: 0}));
        return tl;

    }

    public showXSplitArrowAnimation(reelId: number, symId: number): gsap.core.Timeline {
        const arrowTl: gsap.core.Timeline = gsap.timeline();
        const arrow: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.XSPLIT_ARROW));
        const symPos: number = symId === 1 ? 0 : symId === 2 ? 1 : -1;
        arrowTl.add(() => {
            this.effectsLayer.addChild(arrow);
            arrow.position.set((reelId - 1) * XwaysHoarder2Statics.symbolWidth + XwaysHoarder2Statics.symbolWidth * 0.5, (symPos * XwaysHoarder2Statics.symbolHeight));
            arrow.state.setAnimation(0, "splitArrow", false);
        }, 0);
        //arrowTl.to(arrow, {x: XwaysHoarder2Statics.symbolWidth * 0.5, duration: arrow.skeleton.data.findAnimation("splitArrow").duration});
        arrowTl.to(this, {duration: 0.5});
        arrowTl.add(() => {
            this.effectsLayer.removeChild(arrow);
        });
        return arrowTl;
    }

    public showReelsNoWinOverlay(): gsap.core.Timeline {
        const showOverlayTl: gsap.core.Timeline = gsap.timeline();
        showOverlayTl.to(this.reelsNoWinOverlay, {alpha: 0.75, duration: 0.03});
        return showOverlayTl;
    }

    public hideReelsNoWinOverlay(): gsap.core.Timeline {
        const hideTl: gsap.core.Timeline = gsap.timeline();
        if (this.reelsNoWinOverlay.alpha !== 0) {
            hideTl.to(this.reelsNoWinOverlay, {alpha: 0, duration: 0.03});
        }

        return hideTl;
    }

    public screenShake(dur: number, wiggles: number = 40, isVertical: boolean, movepos?: number): gsap.core.Timeline {
        let moveXVal: number = movepos ? movepos : 3,
            moveYVal: number = movepos ? movepos : 3;
        let wiggleTl: gsap.core.Timeline = gsap.timeline(),
            x: string = Math.random() > 0.5 ? `-=${moveXVal}` : `+=${moveXVal}`,
            y: string = Math.random() > 0.5 ? `-=${moveYVal}` : `-=${moveYVal}`;

        const shakeWiggle = CustomWiggle.create("shakeWiggle", {
            wiggles: wiggles,
            amplitudeEase: Linear.easeNone,
            timingEase: Linear.easeNone
        });
        if (!isVertical) {
            wiggleTl.to(this, {
                duration: dur,
                x: x,
                ease: shakeWiggle
            }, 0);
        }
        wiggleTl.to(this, {
            duration: dur,
            y: y,
            ease: shakeWiggle
        }, 0);
        wiggleTl.to(this, {
            x: 0,
            y: 0,
            duration: 0.01
        });

        return wiggleTl;
    }

    public showRespinOverlay(duration: number): gsap.core.Timeline {
        const addTL: gsap.core.Timeline = gsap.timeline();
        addTL.to(this._respinOverlay, {alpha: 1, duration: duration});
        return addTL;
    }

    public hideRespinOverlay(duration: number): gsap.core.Timeline {
        const remTL: gsap.core.Timeline = gsap.timeline();
        remTL.to(this._respinOverlay, {alpha: 0, duration: duration});
        return remTL;
    }

    public defaultLayering(): void {
        this.addChild(this.layers.maskedNormal);
        this.addChild(this.layers.maskedOver);
        this.addChild(this.reelsNoWinOverlay);
        this.addChild(this.layers.win);
        this.addChild(this.layers.winOver);

        this.addChild(this.layers.overlay);
        this.addChild(this.layers.stickyOverlay);

        this.layers.lockOverlay.addChild(this._respinOverlay!);
        XwaysHoarder2.additionalOverlay.addChild(this.layers.lockOverlay);

    }

    public symbolsToNormalLayer(): void {//use before transitions
        [0, 1, 2, 3, 4, 5].forEach((reelId: number) => {
            [0, 1, 2].forEach((symId: number) => {
                const sym: BasicSymbol = <BasicSymbol>XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(symId).positionable;
                if (sym.symbolName === "SC" || sym.symbolName === "SSC") {
                    if (sym.state !== SymbolStates.STICKY) {
                        sym.getStateAnimation(SymbolStates.START_SPIN)
                    }
                }
            });
        });
    }


    private init() {
        this.layers = new LayersSet();
        this.createReels();
        this._symbolMask = new PIXI.Graphics();
        this._symbolMask.name = "ReelMask"
        this._symbolMask.beginFill(0xFFF678, 1);
        this._symbolMask.drawRect(-60, -48, XwaysHoarder2Statics.symbolWidth * 7, XwaysHoarder2Statics.symbolHeight * 3);
        this._symbolMask.position.set(-136, 136);
        this.addChild(this._symbolMask);
        this.mask = this._symbolMask;

        this.createNoWinOverlay();

        this.addChild(this.layers.maskedNormal);
        this.addChild(this.layers.maskedOver);
        this.addChild(this.reelsNoWinOverlay);
        this.addChild(this.layers.win);
        this.addChild(this.layers.winOver);

        this.addChild(this.layers.overlay);
        this.addChild(this.layers.stickyOverlay);
        this.addChild(this.layers.lockOverlay);

        this.effectsLayer = new PIXI.Container();
        this.effectsLayer.name = "effectsLayer";
        this.addChild(this.effectsLayer);
        this.effectsLayer.position.set(this.layers.maskedNormal.position.x, this.layers.maskedNormal.position.y);

        XwaysHoarder2.additionalOverlay.addChild(this.layers.lockOverlay);
        this.createRespinOverlay();
        this.onResize();

    }

    private createNoWinOverlay(): void {
        this.reelsNoWinOverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.reelsNoWinOverlay.name = "_reelsNoWinOverlay";
        this.reelsNoWinOverlay.height = XwaysHoarder2Statics.symbolHeight * 3;
        this.reelsNoWinOverlay.width = XwaysHoarder2Statics.symbolWidth * 6;
        this.reelsNoWinOverlay.position.x = 360;
        this.reelsNoWinOverlay.position.y = 390;
        this.reelsNoWinOverlay.anchor.set(0.5, 0.5);
        this.reelsNoWinOverlay.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        this.reelsNoWinOverlay.alpha = 0;
        this.reelsNoWinOverlay.tint = XwaysHoarder2Statics.noWinTint;

    }

    private createRespinOverlay(): void {
        this._respinOverlay = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures("respinOverlay")[0]);
        this._respinOverlay.anchor.set(0.5, 0.5);
        this._respinOverlay.scale.set(1.48, 1.65);
        this._respinOverlay.position.set(477, -6);
        this._respinOverlay.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._respinOverlay.alpha = 0;
        this.layers.lockOverlay.addChild(this._respinOverlay);
    }
}